import React, { useState } from 'react'
import { NavLink , useNavigate} from 'react-router-dom'
import {SignInRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';

const Login = () => {
const [username, setusername] = useState('')
const [password, setpassword] = useState('')
const [usernamechecking, setusernamechecking] = useState(false)
const fetchReducer = useSelector((state) => state.FetchDataReducer)

console.log(fetchReducer)

let navigate = useNavigate();
const dispatch = useDispatch()

const InputHandling = (e)=>{
    var U_name = e.target.value
    setusername(U_name)
    if(U_name !== ''){
        let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
    if (reg.test(U_name) === false) {
        setusernamechecking(false)
      return false;
    } 
    else{
        setusernamechecking(true)
    }
    }else {
        setusernamechecking(false)
    }
}

const LoginHandler = () =>{

    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;

   if (reg.test(username) === false) {
    toast.error('Email should be proper!');
    } else if(password === ''){
        toast.error('Password is required');
    } else {
        let obj = {
            email: username,
            password:password
        }
    
        dispatch(SignInRequest({obj:obj,navigate:navigate}))
    }

}


  return (
    <div className='login-screen'>
       <Loader visible={fetchReducer.isloading} />
        <div className='login-screen-shape'>
            <img src='images/login-logo.png'/>
         </div>
         <div className='login-form'>
            <h3>Login</h3>
            <p>Enter valid credential to continue</p>

            <div className='form-group'>
                <label>User Name</label>
                <input type="text" className={`form-control ${usernamechecking ? "confirm" : ""}`} 
                placeholder='User Name'
                value={username}
                onChange={(e)=>InputHandling(e)}
                />
                {
                    usernamechecking ?
                    <i className="fa-solid fa-check"></i>
                    :
                    null
                }
            </div>
            <div className='form-group'>
                <label>Password</label>
                <input className="form-control"
                placeholder='Password'
                type="password"
                value={password}
                onChange={(e)=>setpassword(e.target.value)}
                />
                
            </div>
            <div className='form-group'>
                <button type='button' className='login-btn' onClick={LoginHandler}>LOGIN</button>
            </div>
            <div className='form-group text-center'>
                <NavLink to="/forgot-password" className="theme-color">Forgot Password?</NavLink>
            </div>
         </div>
    </div>
  )
}

export default Login